var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9982 1.42658C11.4452 0.0404549 13.4063 0.0404565 13.8534 1.42658L15.5518 6.69291C15.752 7.31368 16.3304 7.73392 16.9827 7.7325L22.5161 7.7204C23.9725 7.71722 24.5785 9.58236 23.3984 10.4358L18.9146 13.6785C18.3861 14.0608 18.1652 14.7407 18.3681 15.3606L20.0895 20.6195C20.5426 22.0036 18.956 23.1563 17.7796 22.2977L13.3101 19.0355C12.7833 18.6509 12.0683 18.6509 11.5415 19.0355L7.07194 22.2977C5.89554 23.1563 4.30895 22.0036 4.76204 20.6195L6.48346 15.3606C6.68638 14.7407 6.46544 14.0608 5.93692 13.6785L1.45318 10.4358C0.27304 9.58236 0.879062 7.71722 2.33549 7.7204L7.8689 7.7325C8.52115 7.73392 9.09957 7.31368 9.29977 6.69291L10.9982 1.42658Z",
    fill: "#E8D65F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellowStar.a6c210fbdf9950aaa05eaf47399e86ba.svg";
export { ForwardRef as ReactComponent };